export function recordDates(dates = []) {
  const timeline = {}
  dates.forEach(value => {
    const match = /^(\d{4})-(\d{2})/.exec(String(value || ''))
    if (!match || Number(match[2]) < 1 || Number(match[2]) > 12) return
    const [, year, month] = match
    if (!timeline[year]) timeline[year] = []
    if (!timeline[year].includes(month)) timeline[year].push(month)
  })

  return timeline
}
